import { Sun, Moon, Monitor } from 'lucide-react'

// Light / Dark / System, using Lucide's own Sun / Moon / Monitor — the
// conventional triad, so the icons read the way people already expect.
//
// currentColor by default, so these follow the nav foreground token in both
// themes without any extra wiring. Imported individually rather than from a
// barrel object so the bundler only ships these three.
const ICONS = { light: Sun, dark: Moon, system: Monitor }

function ThemeIcon({ theme, size = 18 }) {
  const Icon = ICONS[theme] ?? Monitor
  // aria-hidden because the button itself carries the label — the icon alone
  // cannot say which of three states is active.
  return <Icon size={size} aria-hidden focusable="false" style={{ display: 'block' }} />
}

export default ThemeIcon
